import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralsService } from '@core/services/generals.service';
import { BcAdalAngularService } from 'bc-adal-angular';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  public messageId: string;
  public injector: any;

  constructor(
    private adalService: BcAdalAngularService,
    public generalsService: GeneralsService
  ) {
    this.messageId = this.generalsService.generateMessageId();
  }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    const url = req.url;
    if (url.indexOf('login') < 0) {
      return req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          messageId: this.messageId
        }
      });
    } else {
      return req.clone();
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    return next.handle(this.addToken(req, this.adalService.accessToken)).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            return this.handle401Error(error);
          } else {
            return observableThrowError(error);
          }
        }
      })
    );
  }

  handle401Error(error: any) {
    this.generalsService.logoutMenu();
    return observableThrowError(error);
  }
}
